import Vue from "vue";
import VueRouter from "vue-router";

// Layout
import Layout from "@/Layout";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/index",
    name: "index",
    component: () => import(/* webpackChunkName: "index" */ "../views/indexView/index.vue"),
  },
  {
    path: "/siyu",
    name: "siyu",
    component: () => import("@/views/siyu/index.vue"),
    hidden: true,
    children: [
      {
        path: "yubao",
        name: "预报",
        permission: "yubao",
        component: () => import("@/views/siyu/forecast/index.vue"),
        meta: { title: "预报" },
      },
      {
        path: "yujing",
        name: "预警",
        permission: "yujing",
        component: () => import("@/views/siyu/warning/index.vue"),
        meta: { title: "预警" },
      },
      {
        path: "yuyan",
        name: "预演",
        permission: "yuyan",
        component: () => import("@/views/siyu/yuyan/index.vue"),
        meta: { title: "预演" },
      },
      {
        path: "yuan",
        name: "预案",
        permission: "yuan",
        component: () => import("@/views/siyu/yuan/index.vue"),
        meta: { title: "预案" },
      },
    ],
  },
  {
    path: "/sys",
    name: "sys",
    component: Layout,
    hidden: true,
    redirect: "/sys/warningrelease",
    children: [
      {
        path: "warningrelease",
        component: () => import("@/views/systemView/warningRelease/index.vue"),
        meta: { title: "预警发布" },
        redirect: "warningrelease/forecastWarning",
        children: [
          {
            path: "forecastWarning",
            component: () => import("@/views/systemView/warningRelease/forecastWarning/index.vue"),
            meta: { title: "预报预警", icon: "el-icon-warning-outline" },
          },
          {
            path: "warningDisposal",
            component: () => import("@/views/systemView/warningRelease/warningDisposal/index.vue"),
            meta: { title: "预警处置", icon: "el-icon-phone-outline" },
            redirect: "warningDisposal/main",
            children: [
              {
                path: "main",
                component: () => import("@/views/systemView/warningRelease/warningDisposal/mainView.vue"),
                meta: { keepAlive: true },
              },
              {
                path: "disposal",
                component: () => import("@/views/systemView/warningRelease/warningDisposal/disposalView.vue"),
                meta: { keepAlive: false },
              },
            ],
          },
          {
            path: "warningStatistics",
            component: () => import("@/views/systemView/warningRelease/warningStatistics/index.vue"),
            meta: { title: "预警统计", icon: "el-icon-message" },
          },
          {
            path: "customSms",
            component: () => import("@/views/systemView/warningRelease/customSms/indexView.vue"),
            meta: { title: "通用短信发送", icon: "el-icon-chat-dot-round" },
          },
          {
            path: "customVoice",
            component: () => import("@/views/systemView/warningRelease/customVoice/indexView.vue"),
            meta: { title: "通用语音发送", icon: "el-icon-phone" },
          },
        ],
      },
      {
        path: "publicWarning",
        component: () => import("@/views/systemView/publicWarning/index.vue"),
        meta: { title: "公众预警" },
      },
      {
        path: "comStatistics",
        component: () => import("@/views/systemView/comStatistics/index.vue"),
        meta: { title: "综合统计" },
        redirect: "comStatistics/tfBriefing",
        children: [
          {
            path: "tfBriefing",
            component: () => import("@/views/systemView/comStatistics/tfBriefing/index.vue"),
            meta: { title: "山洪简报", icon: "el-icon-printer" },
          },
          {
            path: "floodStatistics",
            component: () => import("@/views/systemView/comStatistics/floodStatistics/index.vue"),
            meta: { title: "山洪统计", icon: "el-icon-data-line" },
          },
        ],
      },
      {
        path: "eventreporting",
        component: () => import("@/views/systemView/eventReporting/index.vue"),
        meta: { title: "事件上报" },
        redirect: "eventreporting/event",
        children: [
          {
            path: "event",
            component: () => import("@/views/systemView/eventReporting/eventr/mainView.vue"),
            meta: { title: "事件上报", icon: "el-icon-tickets" },
          },
        ],
      },
      {
        path: "basicinformation",
        component: () => import("@/views/systemView/basicInformation/index.vue"),
        meta: { title: "基础信息" },
        redirect: "basicinformation/administrativeVillage",
        children: [
          {
            path: "administrativeVillage",
            component: () => import("@/views/systemView/basicInformation/administrative/index.vue"),
            meta: { title: "行政村名录", icon: "el-icon-office-building" },
          },
          {
            path: "villageslist",
            component: () => import("@/views/systemView/basicInformation/villagesList/index.vue"),
            meta: { title: "村落名录", icon: "el-icon-s-home" },
          },
          {
            path: "placementPoint",
            component: () => import("@/views/systemView/basicInformation/placementPoint/index.vue"),
            meta: { title: "安置点及物资", icon: "el-icon-place" },
          },
          {
            path: "riskArea",
            component: () => import("@/views/systemView/basicInformation/riskArea/index.vue"),
            meta: { title: "风险区域", icon: "el-icon-warning-outline" },
            redirect: "riskArea/main",
            children: [
              {
                path: "main",
                component: () => import("@/views/systemView/basicInformation/riskArea/mainView.vue"),
              },
              {
                path: "detail",
                component: () => import("@/views/systemView/basicInformation/riskArea/detailView.vue"),
              },
            ],
          },
          {
            path: "defensetarget",
            component: () => import("@/views/systemView/basicInformation/defenseTarget/index.vue"),
            meta: { title: "防御对象", icon: "el-icon-user-solid" },
            redirect: "defensetarget/main",
            children: [
              {
                path: "main",
                component: () => import("@/views/systemView/basicInformation/defenseTarget/mainView.vue"),
              },
              {
                path: "detail",
                component: () => import("@/views/systemView/basicInformation/defenseTarget/detailView.vue"),
              },
            ],
          },
          {
            path: "personresponsible",
            component: () => import("@/views/systemView/basicInformation/personResponsible/index.vue"),
            meta: { title: "责任人管理", icon: "el-icon-receiving" },
          },
          {
            path: "siteAssociation",
            component: () => import("@/views/systemView/basicInformation/siteAssociation/index.vue"),
            meta: { title: "站点关联", icon: "el-icon-connection" },
            redirect: "siteAssociation/main",
            children: [
              {
                path: "main",
                component: () => import("@/views/systemView/basicInformation/siteAssociation/mainView.vue"),
              },
              {
                path: "detail",
                component: () => import("@/views/systemView/basicInformation/siteAssociation/detailView.vue"),
                name: "siteAssociationDetail",
              },
            ],
          },
          {
            path: "rainfallwarning",
            component: () => import("@/views/systemView/basicInformation/rainfallWarning/index.vue"),
            meta: { title: "雨量预警指标", icon: "el-icon-heavy-rain" },
          },
          {
            path: "smsProviderConfig",
            component: () => import("@/views/systemView/basicInformation/smsProviderConfig/index.vue"),
            meta: { title: "短信运营商配置", icon: "el-icon-message" },
          },
        ],
      },
      {
        path: "equipmentmanagement",
        component: () => import("@/views/systemView/equipmentManagement/index.vue"),
        meta: { title: "设备管理" },
        redirect: "equipmentmanagement/soundandlight",
        children: [
          {
            path: "soundandlight",
            component: () => import("@/views/systemView/equipmentManagement/soundAndlight/index.vue"),
            meta: { title: "声光电设备", icon: "el-icon-set-up" },
          },
          {
            path: "hydrology",
            component: () => import("@/views/systemView/equipmentManagement/hydrology/index.vue"),
            meta: { title: "水文设备", icon: "el-icon-set-up" },
          },
        ],
      },
      {
        path: "systemmanagement",
        component: () => import("@/views/systemView/systemManagement/index.vue"),
        meta: { title: "系统管理" },
        redirect: "systemmanagement/usermanagement",
        children: [
          {
            path: "usermanagement",
            component: () => import("@/views/systemView/systemManagement/userManagement/index.vue"),
            meta: { title: "用户管理", icon: "el-icon-s-custom" },
          },
        ],
      },
    ],
  },
  {
    path: "/visualization",
    component: () => import("@/views/visualization/index"),
    hidden: true,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
